module.exports = __webpack_public_path__ + "img/p12.027eb25d.png";